// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"style_BackButton__k1Hmi","text":"style_text__3vwE4"};